import { Target } from '../../../ui/shared/enums/Target';
import { RelAttribute } from '../../../ui/shared/enums/RelAttribute';
import type { ExternalDestination } from '../../../ui/arche/primitives/Navigations/ExternalDestination';
import type { SkinDestination } from '../../../ui/shared/interfaces/SkinDestination';
import {
  defaultBaseDestination,
  defaultBaseSkin,
  placeholderBaseDestination,
  placeholderBaseSkin,
} from './BaseDestinationDefaults';

export const defaultExternalDestination: Partial<ExternalDestination & SkinDestination> = {
  ...defaultBaseDestination,
  ...defaultBaseSkin,
  rel: RelAttribute.PreventReferrerAndFollow,
  openInNewTab: true,
  target: Target.Blank,
} as unknown as Partial<ExternalDestination & SkinDestination>;

export const placeholderExternalDestination: Partial<ExternalDestination & SkinDestination> = {
  ...placeholderBaseDestination,
  ...placeholderBaseSkin,
  link: 'https://www.google.com',
  text: 'Go to Google',
  rel: RelAttribute.PreventReferrerAndFollow,
  openInNewTab: true,
  target: Target.Blank,
} as unknown as Partial<ExternalDestination & SkinDestination>;
